<!--
In more recent versions of AG Grid, the "ag-theme-material" class is not added
for styling.  However, we still put it on the container in order for our custom
styling to take effect and be consistent with Gibbon.
-->
<div #container class="table ag-theme-material" [class.table_double-header]="isDoubleHeader">
  <ag-grid-angular [theme]="theme" [style.height]="domLayout() === 'autoHeight' ? undefined: gridHeight" class="table__content" [domLayout]="domLayout()"
    [gridOptions]="mergedGridOptions" [columnDefs]="fixedColumnDefs()" rowSelection="multiple"
    (gridReady)="onGridReady($event)" [masterDetail]="true"
    [isServerSideGroupOpenByDefault]="isServerSideGroupOpenByDefault" [isServerSideGroup]="isServerSideGroup"
    [getServerSideGroupKey]="getServerSideGroupKey()" suppressRowTransform="true" [detailRowHeight]="detailRowHeight()"
    (filterChanged)="onFilterChanged()" (sortChanged)="onSortChange()" [paginateChildRows]="paginateChildRows"
    [autoGroupColumnDef]="autoGroupColumnDef()" [treeData]="treeData()" [rowData]="rowData()" filterParams
    (gridSizeChanged)="onGridSizeChanged()" [overlayNoRowsTemplate]="overlayNoRowsTemplate()">
  </ag-grid-angular>
  @if (paginationEnabled()) {
  <div class="table__pagination">
    <div class="table__page-size">
      <span class="table__label">Page Size</span> <!-- fixme -->
      <select class="table__select" (change)="onPageSizeChange($event)" [value]="paginationParams().recordsPerPage">
        <option [value]="10">10</option>
        <option [value]="15">15</option>
        <option [value]="25">25</option>
        <option [value]="50">50</option>
        <option [value]="100">100</option>
      </select>
    </div>
    <div class="table__navigation">
      <div class="table__pagination-items">
        {{paginationParams().recordMessage}}
      </div>
      <div class="table__pagination-pages">
        <button type="button" (click)="onFirstPage()" [disabled]="paginationParams().backDisabled"
          class="table__navigation-button" [class.table__navigation-button_disabled]="paginationParams().backDisabled">
          <svg-icon icon="firstPage" size="fill" class="table__navigation-icon"></svg-icon>
        </button>
        <button type="button" (click)="onPreviousPage()" [disabled]="paginationParams().backDisabled"
          class="table__navigation-button" [class.table__navigation-button_disabled]="paginationParams().backDisabled">
          <svg-icon icon="previousPage" size="fill" class="table__navigation-icon"></svg-icon>
        </button>
        <span>{{paginationParams().pageMessage}}</span>
        <button type="button" (click)="onNextPage()" [disabled]="paginationParams().forwardDisabled"
          class="table__navigation-button" [class.table__navigation-button_disabled]="paginationParams().forwardDisabled">
          <svg-icon icon="nextPage" size="fill" class="table__navigation-icon"></svg-icon>
        </button>
        @if (paginationParams().totalPages !== null) {
        <button type="button" (click)="onLastPage()" [disabled]="paginationParams().forwardDisabled"
          class="table__navigation-button" [class.table__navigation-button_disabled]="paginationParams().forwardDisabled">
          <svg-icon icon="lastPage" size="fill" class="table__navigation-icon"></svg-icon>
        </button>
        }
      </div>
    </div>
  </div>
  }
</div>

